<div class="tw:flex tw:flex-wrap tw:-mx-[15px] tw:mb-4">
  <div class="tw:w-full tw:px-[15px]">
    <h3>Choose a subject to view its timeline</h3>
  </div>
</div>
<div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
  <div class="tw:w-1/2 tw:px-[15px]">
    <select-timeline-subject [studentId]="studentId"
                              [studentName]="studentName"
                              [placementId]="placementId"
                              [clientId]="clientId">
    </select-timeline-subject>
  </div>
</div>
